import { useCallback, useMemo } from 'react';
import { useLocation, useNavigate, useParams } from 'react-router';
import { type AudienceDetailsTabs, AudienceDetailsTabsValues, isAudienceDetailsTab } from '../../../types.ts';

export function useAudienceTabs() {
  const { audienceUid } = useParams<{ audienceUid: string }>();
  const navigate = useNavigate();
  const location = useLocation();
  const tabSelectedByLocation = useMemo(() => {
    const tab = location.pathname.split('/').pop();

    return tab && isAudienceDetailsTab(tab) ? tab : AudienceDetailsTabsValues.Details;
  }, [location.pathname]);

  const changeTab = useCallback(
    (_event: unknown, value: AudienceDetailsTabs) => {
      navigate(`/audiences/${audienceUid}/${value}`, { replace: true, state: location.state });
    },
    [audienceUid, location.state, navigate]
  );

  return useMemo(() => ({ activeTab: tabSelectedByLocation, changeTab }), [tabSelectedByLocation, changeTab]);
}
